import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import BillingAndAlerts from "../components/payments-and-alerts/BillingAndAlerts";
import { fetchBillingAndAlerts } from "../actions/billingAndAlertsAction";
import { fetchViewProfile } from "../actions/viewProfileActions";
import { fetchdownIndicatorInfo } from "../components/behaviors/DownIndicatorBehavior";

const BillingAndAlertsContainer = ({
  fetchViewProfile,
  fetchBillingAndAlerts,
  fetchdownIndicatorInfo,
  billingAndAlertsData,
  profileData
}) => {

  const { userProfile } = profileData;
  const { alertsData } = billingAndAlertsData;

  const isLoading = useMemo(()=>{
    return !alertsData || !userProfile?.email;
  },[alertsData, userProfile?.email]);

  useEffect(() => {
    fetchBillingAndAlerts();
    fetchViewProfile();
    fetchdownIndicatorInfo();
  }, [fetchBillingAndAlerts, fetchViewProfile, fetchdownIndicatorInfo]);

  return (
    <BillingAndAlerts
      isLoading={isLoading}
      accounts={alertsData}
      email={userProfile?.email}
      userProfile={userProfile}
    />
  )
};

const mapStateToProps = state => ({
  billingAndAlertsData: state.billingAndAlertsData,
  profileData: state.profileData
});

const mapDispatchToProps = {
  fetchBillingAndAlerts,
  fetchViewProfile,
  fetchdownIndicatorInfo
};

BillingAndAlertsContainer.propTypes = {
  fetchViewProfile: PropTypes.func.isRequired,
  fetchBillingAndAlerts: PropTypes.func.isRequired,
  fetchdownIndicatorInfo: PropTypes.func.isRequired,
  billingAndAlertsData: PropTypes.object.isRequired,
  profileData: PropTypes.object.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BillingAndAlertsContainer);
